module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/200MP Ultrahigh Pixel Camera with Autofocus.4b2a4a5d.png";